'use strict';

var config = [

    {

        route: '/most-innovative-companies/:year$',

        method: ['GET'],

        controller: 'renderMIC',

        view: {
            route: 'most-innovative-companies/:year',
            alias: 'most-innovative-companies',
            file: 'js/mic.js'
        },

        timeout: 2000

    },

    {
        route: '/mic/:year',

        method: ['GET'],

        controller: 'renderMIC',

        view: {
            route: 'mic/:year',
            alias: 'mic',
            file: 'js/mic.js'
        },

        timeout: 2000

    }

];

exports.config = config;
